import Model from './Model'
import AgencyEventFeesStore from 'Stores/AgencyEventFeesStore'
// import { assign } from 'lodash'

class AgencyEventFee extends Model {
  store = AgencyEventFeesStore

  constructor (initialData) {
    initialData.descriptionWithCost = `${initialData.description} ($${parseFloat(initialData.cost).toFixed(2)}/event)`

    super(initialData, {
      momentKeys: [],
    })
  }

  /**
   * Updates the fields on the AgencyEventFee model. Passes itself into
   * the MobX store update function to perform the API action.
   * @param {Object} params Fields to update. `id` key is required.
   * @return Promise to the store's update function.
   */
  // update (params) {
  //   assign(this, params)
  //   return this.store.update(this)
  // }

  /**
   * Destroys the AgencyEventFee model. Passes itself into the MobX store
   * remove function to perform the API action.
   * @return Promise to the store's remove function.
   */
  // destroy () {
  //   return this.store.remove(this)
  // }
}

export default AgencyEventFee
